import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryCouponExpired extends AnnualSummaryError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('The promotional coupon is expired', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualSummaryCouponExpired;
